import { render, staticRenderFns } from "./CRUseBalance.vue?vue&type=template&id=6858a76e&scoped=true&"
import script from "./CRUseBalance.vue?vue&type=script&lang=js&"
export * from "./CRUseBalance.vue?vue&type=script&lang=js&"
import style0 from "./CRUseBalance.vue?vue&type=style&index=0&id=6858a76e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6858a76e",
  null
  
)

export default component.exports